import React, { Component } from "react";
import { Modal } from "antd-mobile";
import styled from "styled-components";
import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";
import "./index.css";
import Theme from "../../utils/Theme";

const StyledContainer = styled.div`
  max-height: 80vh;
  display: flex;
  flex-direction: column;
  padding: 5px 10px;
  justify-content: center;
`;

const StyledContent = styled.div`
  height: auto;
  overflow: scroll;
  text-align: left;
`;

const StyledCloseButton = styled.div`
  cursor: pointer;
  background: ${Theme.PrimaryColor};
  &:hover {
    opacity: 0.5;
    text-decoration: underline;
  }
  margin: 5px 0px;
  padding: 5px 25px;
  box-shadow: 0 4px 6px -5px grey;
  border-radius: 2px;
  color: #fff;
  font-weight: bold;
  font-size: 0.8em;
  text-align: center;
`;

const StyledDescription = styled.span`
  padding: 10px 0px;
  font-size: 1.5em;
  font-weight: bold;
  text-align: left;
`;

class InfoModal extends Component {
  onInfoModalClose = () => {
    const { onInfoModalClose } = this.props;
    onInfoModalClose();
  };

  render() {
    const { shouldShow, description, onTouchStart } = this.props;

    return (
      <Modal
        className={"infomodal"}
        visible={shouldShow}
        transparent
        maskClosable={false}
        wrapProps={{ onTouchStart: onTouchStart }}
      >
        <StyledContainer>
          <StyledDescription>
            <FormattedMessage
              id="infomodal.description"
              defaultMessage="Description"
              description="Description Header"
            />
          </StyledDescription>
          <StyledContent>{description}</StyledContent>
          <StyledCloseButton onClick={this.onInfoModalClose}>
            <FormattedMessage
              id="infomodal.close"
              defaultMessage="Close"
              description="Close Info Button"
            />
          </StyledCloseButton>
        </StyledContainer>
      </Modal>
    );
  }
}

InfoModal.propTypes = {
  shouldShow: PropTypes.bool.isRequired,
  description: PropTypes.object.isRequired,
  onInfoModalClose: PropTypes.func.isRequired,
  onTouchStart: PropTypes.func.isRequired
};

InfoModal.defaultProps = {
  shouldShow: false
};

export default InfoModal;



// WEBPACK FOOTER //
// ./src/components/InfoModal/index.js